import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import JobCard from "../components/JobCard";
import { Building2, MapPin, ArrowLeft, Shield, BadgeCheck } from "lucide-react";

export default function EmployerDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/employers/${id}`).then((r) => setData(r.data));
  }, [id]);

  if (!data) return <div className="max-w-7xl mx-auto p-12 text-zinc-500 font-mono-alt uppercase text-sm">Loading&hellip;</div>;

  const { employer, jobs } = data;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Link to="/employers" className="text-sm text-zinc-500 hover:text-yellow-500 uppercase tracking-wider flex items-center gap-1 mb-6">
        <ArrowLeft size={14} /> All employers
      </Link>

      <div className="border border-zinc-800 bg-zinc-950/50 p-8 mb-10">
        <Building2 size={28} className="text-yellow-500 mb-4" />
        <div className="text-xs font-mono-alt uppercase tracking-widest text-yellow-500 mb-2">{employer.industry}</div>
        <h1 className="font-display text-4xl md:text-6xl uppercase leading-none flex items-center gap-3 flex-wrap">{employer.name} {employer.verified && <BadgeCheck className="text-yellow-500" size={40} />}</h1>
        <div className="mt-4 flex items-center gap-4 text-sm text-zinc-400">
          <span className="flex items-center gap-1"><MapPin size={14} />{employer.location}</span>
          {employer.registered_partner && (
            <span className="flex items-center gap-1 text-yellow-500 font-bold uppercase text-xs tracking-wider">
              <Shield size={12} /> Registered Partner
            </span>
          )}
        </div>
        <p className="mt-6 text-zinc-300 max-w-3xl leading-relaxed">{employer.description}</p>
      </div>

      <div className="text-xs font-mono-alt uppercase text-yellow-500 tracking-widest mb-2">Open Positions</div>
      <h2 className="font-display text-3xl md:text-4xl uppercase leading-none mb-8">{jobs.length} apprenticeship{jobs.length !== 1 ? "s" : ""}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {jobs.map((j, i) => (<JobCard key={j.id} job={j} index={i} />))}
      </div>
    </div>
  );
}
